import { css } from "@compiled/react";

import type { SVGProps } from "@atlaskit/icon/types";
import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

export const VideoHeroConfluenceSoftwarePageVariantBPSRedesign = () => {
    return (
        <section>
            <div css={HeroWrapperStyles}>
                <div css={VideoContainerStyles}>
                    <svg
                        css={[figureCommon, figureYellow]}
                        width="100%"
                        height="100%"
                        viewBox="0 0 487 348"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 0H333.864L487 348L0 322.022V0Z"
                            fill="#FCA700"
                        />
                    </svg>
                    <svg
                        css={[figureCommon, figurePurple]}
                        width="100%"
                        height="100%"
                        viewBox="0 0 769 172"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0 0L769 46.6667V172L0 153.333V0Z"
                            fill="#BF63F3"
                        />
                    </svg>
                    <svg
                        css={[figureCommon, figureSplash]}
                        width="70"
                        height="81"
                        viewBox="0 0 70 81"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M56.2192 44.8534C56.6627 45.0897 52.2573 57.4467 48.998 61.7055C50.0474 63.4666 50.1513 66.571 48.8233 69.0503C52.789 77.3851 55.0935 62.6946 55.7214 58.0831C53.3262 60.1391 57.5105 53.9554 57.1874 52.495C56.9575 53.0859 61.4299 41.2128 57.771 43.2186C57.6764 42.7278 55.5176 44.8873 56.2141 44.8448L56.2192 44.8534Z"
                            fill="#101214"
                        />
                        <path
                            d="M25.1561 43.4585C24.3385 46.1691 22.2142 47.7028 19.4824 48.7836C16.2392 57.9336 29.71 47.8574 32.9434 45.3718C32.9434 45.3718 38.7151 41.1291 38.3922 41.857C39.726 42.0051 49.9702 37.2974 45.7419 35.3004C43.9358 35.9227 41.3043 38.4221 40.0408 37.7083C36.8673 36.8172 29.6594 42.9867 25.1527 43.4722L25.1561 43.4585Z"
                            fill="#101214"
                        />
                        <path
                            d="M16.0846 10.2046C12.0077 14.8691 24.269 16.2815 28.3809 18.2199C28.3809 18.2199 32.533 20.4601 34.0443 20.3395C33.4416 20.0118 48.6151 27.0924 42.3044 20.0968C42.0593 20.0566 36.8102 17.597 36.8102 17.597C30.9417 12.3983 22.8521 10.7001 16.076 10.2098L16.0846 10.2046Z"
                            fill="#101214"
                        />
                    </svg>
                    <video
                        playsInline={true}
                        muted={true}
                        preload="auto"
                        css={videoImgContainerStyles}
                        poster="https://dam-cdn.atl.orangelogic.com/AssetLink/8kn0so12p6356218504lmb1ynwds0b38.webp"
                        autoPlay
                        loop
                    >
                        <source
                            src="https://dam-cdn.atl.orangelogic.com/AssetLink/rl33vm2oohv3a004u5rs32nr6hbysu8r.webm"
                            type="video/webm"
                        />
                    </video>
                </div>
                <div css={featureListStyles}>
                    {featureList.map(({ icon, message }, index: number) => (
                        <div css={featureItemStyles} key={index}>
                            {icon}
                            <p css={productFeatureItemStyles}>{message}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const iconWidthFixStyles = css({
    width: 48,
    height: 48,
    minWidth: 48,
    [media.below.md]: {
        width: 24,
        height: 24,
        minWidth: 24
    }
});

const HeroWrapperStyles = css({
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: 40,
    paddingInline: token("space.200"),
    maxWidth: "1200px",
    marginInline: "auto",
    alignItems: "center",
    [media.above.sm]: {
        gridTemplateColumns: "1fr 2fr"
    }
});

const VideoContainerStyles = css({
    position: "relative",
    aspectRatio: "265 / 150",
    [media.above.sm]: {
        order: 2
    }
});

const figureCommon = css({
    mixBlendMode: "multiply",
    position: "absolute"
});

const figureSplash = css({
    insetBlockEnd: "-7%",
    insetInlineStart: "-13%",
    [media.below.md]: {
        display: "none"
    }
});

const figureYellow = css({
    aspectRatio: "487 / 348",
    insetInlineStart: "-12%",
    insetBlockStart: "-2%"
});

const figurePurple = css({
    aspectRatio: "769 / 172",
    insetInlineStart: "0%",
    insetBlockEnd: "-7%",
    height: "40%"
});

const featureListStyles = css({
    display: "flex",
    flexDirection: "column",
    [media.below.sm]: {
        marginInline: "max(21px, calc(100% - 400px)/2)",
        marginBlockStart: "10px"
    }
});

const videoImgContainerStyles = css({
    aspectRatio: "265 / 150",
    width: "96%",
    position: "absolute",
    insetBlockStart: "50%",
    insetInlineStart: "50%",
    transform: "translate(-50%, -50%)"
});

const featureItemStyles = css({
    display: "flex",
    justifyContent: "left",
    gap: "15px",
    marginBlockEnd: "30px",

    maxWidth: "350px",
    [media.below.sm]: {
        marginBlockEnd: "10px"
    }
});

const productFeatureItemStyles = css({
    fontFamily: "Charlie Text",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "20px !important",
    lineHeight: "28px",
    color: "#172B4D",
    marginBlock: "0",
    [media.below.md]: {
        fontSize: "14px !important",
        lineHeight: "20px !important"
    }
});

const ScoreCardIcon = (props: SVGProps) => {
    const { label } = props;
    return (
        <svg
            css={iconWidthFixStyles}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={label}
        >
            <g clipPath="url(#clip0_5430_42434)">
                <path
                    d="M12 24C12 17.3726 17.3726 12 24 12C30.6274 12 36 17.3726 36 24H40C40 15.1634 32.8366 8 24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40V36C17.3726 36 12 30.6274 12 24Z"
                    fill="#1868DB"
                />
                <path
                    d="M34.9286 28.9646C33.7288 31.6009 31.6009 33.7288 28.9646 34.9286L30.6216 38.5693C34.1369 36.9694 36.9694 34.1369 38.5693 30.6216L34.9286 28.9646Z"
                    fill="#1868DB"
                />
                <path
                    d="M22.9999 29.8283L32.4141 20.4141L29.5857 17.5857L22.9999 24.1715L20.4141 21.5857L17.5857 24.4141L22.9999 29.8283Z"
                    fill="#1868DB"
                />
            </g>
            <defs>
                <clipPath id="clip0_5430_42434">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const PageDuplicateIcon = (props: SVGProps) => {
    const { label } = props;
    return (
        <svg
            css={iconWidthFixStyles}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={label}
        >
            <g clipPath="url(#clip0_5430_42436)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 11H32V33H10V11ZM27 17H15V20H27V17ZM27 24H15V27H27V24Z"
                    fill="#1868DB"
                />
                <path d="M36 20V36H20V40H40V20H36Z" fill="#1868DB" />
            </g>
            <defs>
                <clipPath id="clip0_5430_42436">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const LinkIcon = (props: SVGProps) => {
    const { label } = props;
    return (
        <svg
            css={iconWidthFixStyles}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label={label}
        >
            <g clipPath="url(#clip0_5430_42432)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M26.1213 36.0209C22.2161 39.9261 15.8845 39.9261 11.9792 36.0209C8.07399 32.1156 8.07399 25.784 11.9792 21.8788L15.5148 18.3432L18.3432 21.1716L14.8076 24.7072C12.4645 27.0503 12.4645 30.8493 14.8076 33.1924C17.1508 35.5356 20.9498 35.5356 23.2929 33.1924L26.8284 29.6569L29.6569 32.4853L26.1213 36.0209Z"
                    fill="#1868DB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.0207 26.1214C39.926 22.2161 39.926 15.8845 36.0207 11.9792C32.1155 8.07399 25.7839 8.07398 21.8786 11.9792L18.3431 15.5148L21.1715 18.3432L24.7071 14.8076C27.0502 12.4645 30.8492 12.4645 33.1923 14.8077C35.5354 17.1508 35.5354 20.9498 33.1923 23.2929L29.6568 26.8285L32.4852 29.6569L36.0207 26.1214Z"
                    fill="#1868DB"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.4644 20.3641L20.4644 30.3641L17.636 27.5357L27.636 17.5356L30.4644 20.3641Z"
                    fill="#1868DB"
                />
            </g>
            <defs>
                <clipPath id="clip0_5430_42432">
                    <rect width="48" height="48" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

const featureList = [
    {
        icon: <LinkIcon label="Link icon" />,
        message: "Align your team under a single source of truth"
    },
    {
        icon: <ScoreCardIcon label="Scorecard icon" />,
        message: "Eliminate time-consuming tool hopping"
    },
    {
        icon: <PageDuplicateIcon label="Page Duplicate Icon" />,
        message: "Link documentation to Jira for automatic updates"
    }
];
